module.exports = __webpack_public_path__ + "media/spa/flow_step_04-50690bbc.svg";